// Whether a menu item is the page you are on.

import type { NavRailItem } from './nav-tree.types';

/** True for the route itself and every page beneath it, ignoring case and any
 *  query the link carries. */
function isAtOrUnder(route: string, pathname: string): boolean {
  const path = pathname.toLowerCase();
  const base = route.split(/[?#]/)[0].toLowerCase();
  return path === base || path.startsWith(`${base}/`);
}

/** An item is current on its own route and the pages beneath it, except the
 *  ones another item owns. */
export function isNavItemActive(
  item: Pick<NavRailItem, 'to' | 'excludes'>,
  pathname: string,
): boolean {
  if (!isAtOrUnder(item.to, pathname)) return false;
  return !(item.excludes ?? []).some((route) => isAtOrUnder(route, pathname));
}
